import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { KlaHttpService } from '../services/kla.http.service';
import { v4 as uuid } from 'uuid';
import { CommonModule } from '@angular/common';
import { NewActionTaxonomyGoalsComponent } from '../new-action-taxonomy-goals/new-action-taxonomy-goals.component';
import { MatExpansionModule } from '@angular/material/expansion';


@Component({
  selector: 'kla-new-action-taxonomy-category',
  templateUrl: './new-action-taxonomy-category.component.html',
  styleUrls: ['./new-action-taxonomy-category.component.scss'],
  standalone: true,
  imports: [ CommonModule, NewActionTaxonomyGoalsComponent, MatExpansionModule ]
})
export class NewActionTaxonomyCategoryComponent implements OnInit {

  @Input()
  public panel: any;
  @Input()
  public config: any;

  panelOpenState: boolean = false;

  image: string;

  panelId = uuid();

  constructor(
    private httpService: KlaHttpService,
    private cdr: ChangeDetectorRef
   ) { }

   get imageAlt() {
    return this.panel.image?.alt;
   }

   ngOnInit(): void {
    this.getImage();
   }

   getImage() {
    if(!this.panel.image.cropConfig) {
      this.image = this.panel.image?.url;
    } else {
      const imageConfig: any = {
        id: String(this.panel.image?.id),
        width: 320,
        height: undefined,
        crop_config: this.panel.image?.cropConfig
      };
      this.image = this.httpService.getCroppedImagePath(imageConfig);
    }
   }


   handleOpened() {
     this.panelOpenState = true;
     this.cdr.markForCheck();
      //Scroll into panel functionality
      // setTimeout(() => {
      //   const options = {
      //     behavior: "smooth" as ScrollBehavior,
      //     block: "start" as ScrollLogicalPosition,
      //     inline: "center" as ScrollLogicalPosition
      //   };
      //    let panel = document.getElementById(this.panelId);
      //    panel.scrollIntoView(options);
      //  }, 500)
   }

   handleClosed() {
     this.panelOpenState = false;
     this.cdr.markForCheck();
   }

}
